/**
 * Normalización de lo que se escribe a mano en el registro de Rastreo.
 *
 * Existe para que la misma cosa escrita de dos formas no termine siendo dos
 * registros: «abc-123» y «ABC 123» son la misma placa; un celular con «+57»,
 * espacios o guiones es el mismo que sus diez dígitos solos; «1.000.000» y
 * «1000000», la misma cédula.
 *
 * Solo quita adornos. No adivina: un teléfono de 9 dígitos sigue teniendo 9 y el
 * esquema lo rechaza (constitución, Art. 3).
 */

/** Mayúsculas, sin espacios, guiones ni puntos. */
export function normalizePlate(value: string): string {
  return value.toUpperCase().replace(/[\s.\-_]/gu, "");
}

/** Solo dígitos, sin el indicativo de Colombia si viene con él. */
export function normalizePhone(value: string): string {
  const digits = value.replace(/\D/gu, "");
  return digits.length === 12 && digits.startsWith("57") ? digits.slice(2) : digits;
}

/**
 * Sin puntos ni espacios y en mayúsculas. El guion se conserva: separa el dígito
 * de verificación del NIT, y quitarlo convertiría «900123456-7» en otro número.
 */
export function normalizeDocument(value: string): string {
  return value.toUpperCase().replace(/[\s.]/gu, "");
}

/** Los últimos 4 caracteres del identificador. Es todo lo que la pantalla necesita. */
export function identifierTail(identifier: string): string {
  return identifier.slice(-4);
}

/** Para buscar sin que importen mayúsculas ni tildes: «Bogotá» encuentra «bogota». */
export function searchKey(value: string): string {
  return value
    .normalize("NFD")
    .replace(/[̀-ͯ]/gu, "")
    .toLowerCase()
    .trim();
}
